import { useGiftWrapContext } from '../../../../context/GiftWrapContext';

export function useViewModel() {
  const {
    priceModalOpen,
    setPriceModalOpen,
    setActivePersonalisation,
    activeProduct,
    personalisationChoices,
    setPersonalisationChoices,
    wrapOptions,
    calculateGiftWrapTotal,
    calculateTotalPrice
  } = useGiftWrapContext();
  const editChoice = (idx) => {
    //Set activeChoice
    const choice = personalisationChoices[`${idx}`];
    if (choice) {
      setActivePersonalisation(choice);
      setPriceModalOpen(false);
    }
  };
  const removeChoice = (idx) => {
    //Remove choice from personalisationChoices
    personalisationChoices.splice(idx, 1);
    setPersonalisationChoices([...personalisationChoices]);
    setPriceModalOpen(false);
  };
  const handleClose = () => {
    setPriceModalOpen(false);
  };

  // Use centralized price calculation values (now useMemo values, not functions)
  const giftWrapTotal = calculateGiftWrapTotal;
  const totalPrice = calculateTotalPrice;

  const getTitle = (choice) => {
    const allOptions = wrapOptions.flatMap((option) =>
      option.variants.map((variant) => ({
        ...variant
      }))
    );
    const parentId = wrapOptions.find((option) => option.product_id === choice.parentId);
    const o = allOptions.find((option) => option.id === choice.vId_gift);
    const title = o?.title === 'Default Title' ? parentId?.title : o?.title;
    return title;
  };
  return {
    priceModalOpen,
    setPriceModalOpen,
    activeProduct,
    personalisationChoices,
    editChoice,
    removeChoice,
    handleClose,
    giftWrapTotal,
    totalPrice,
    getTitle,
    wrapOptions
  };
}
